// An image served by an authenticated API endpoint (challan photos live in private S3): fetched
// with the JWT and shown from an object URL, revoked on unmount.

import { useEffect, useState } from "react";
import { ImageOff, Loader2 } from "lucide-react";

import { apiFetchBlob } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

export function AuthImage({ path, alt, className }: { path: string; alt: string; className?: string }) {
  const { token } = useAuth();
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancel = false;
    apiFetchBlob(path, token)
      .then((blob) => {
        if (cancel) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancel) setFailed(true);
      });
    return () => {
      cancel = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path, token]);

  if (url) return <img src={url} alt={alt} className={className} />;
  return (
    <div className={cn("flex items-center justify-center bg-muted text-muted-foreground", className)}>
      {failed ? <ImageOff className="size-5" /> : <Loader2 className="size-5 animate-spin" />}
    </div>
  );
}
